import { render, staticRenderFns } from "./PreparationVisaList.vue?vue&type=template&id=0c9c0e01&"
import script from "./PreparationVisaList.vue?vue&type=script&lang=js&"
export * from "./PreparationVisaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports